export const isDAM = (deviceCode: string): boolean => deviceCode.startsWith('DAM');
export const isDUT = (deviceCode: string): boolean => deviceCode.startsWith('DUT');
